import React from 'react';
import {
    Details,
    DetailsStringValue,
    DetailsReactNodeValue,
    DetailsArrayValue,
    AddressLink,
    ExamStatus,
    Card,
    ExamType,
    MappedExamTypes,
    MappedExamStatuses,
    AppType,
    ProtocolLink,
    Status,
} from 'components';
import { IExamDetails } from 'components/models';
import { Color, createExamDate, getFormattedDuration } from '_helpers';
import moment from 'moment-timezone';

const ExamInfoTab = ({
    examDetails, appType, withoutPadding,
}: IProps) => {
    const getInfoRowsFromExamDetails = () => {
        const infoRows: (DetailsReactNodeValue | DetailsStringValue | DetailsArrayValue)[] = [
            new DetailsStringValue('Тип экзамена', examDetails.type === ExamType.Recertification ? 'Признание аттестата' : MappedExamTypes[examDetails.type].text),
            new DetailsStringValue('ЦОК', examDetails.qualificationEvaluationCenterName),
            new DetailsStringValue('ЭЦ', examDetails.examinationCenterName),
            new DetailsStringValue('Дата экзамена', examDetails.date.format('DD.MM.YYYY')),
            new DetailsStringValue('Время проведения', createExamDate(examDetails.actualStartTime || examDetails.date)),
            new DetailsReactNodeValue('Место проведения', <AddressLink city={examDetails.city} address={examDetails.address} withoutLink />),
            new DetailsStringValue('Общее время', examDetails.practiceDefense ? '-' : getFormattedDuration(examDetails.duration)),
        ];

        if (examDetails.applicationsLimit) {
            infoRows.push(new DetailsStringValue('Количество мест', `${examDetails.applicationsLimit}`));
        }

        infoRows.push(
            new DetailsStringValue('', ''),
            new DetailsStringValue('Теория', 'Ответы на вопросы'),
            new DetailsStringValue('Заданий в теории', `${examDetails.theoreticalQuestionsCount}`),
            new DetailsStringValue('Время на теорию', `${examDetails.theoreticalPartDuration} мин.`),
            new DetailsStringValue('', ''),
        );


        if (examDetails.practiceDefense) {
            infoRows.push(new DetailsStringValue('Практика', 'Защита проекта'));
        } else {
            infoRows.push(
                new DetailsStringValue('Практика', 'Решение задачи'),
                new DetailsStringValue('Заданий в практике', `${examDetails.practicalQuestionsCount}`),
                new DetailsStringValue('Время на практику', `${examDetails.practicalPartDuration} мин.`),
            );
        }

        const { status } = examDetails;

        if (appType !== AppType.Applicant) {
            infoRows.push(new DetailsReactNodeValue('Статус', <Status status={MappedExamStatuses[status]} />));
        }

        if (appType === AppType.Expert && status === ExamStatus.Finished) {
            infoRows.push(new DetailsStringValue('Требуется', 'Написание рекомендации для заключений', Color.Orange));
        }

        if (status === ExamStatus.NokProtocolSigned || status === ExamStatus.AkProtocolSigned
            || status === ExamStatus.SovietProtocolSignedByMembers || status === ExamStatus.SovietProtocolSignedByChairman) {
            if (examDetails.nokProtocolUrl) infoRows.push(new DetailsReactNodeValue('Протокол НОК', <ProtocolLink url={examDetails.nokProtocolUrl} />));
            if (examDetails.akProtocolUrl) infoRows.push(new DetailsReactNodeValue('Протокол АК', <ProtocolLink url={examDetails.akProtocolUrl} />));
            if (examDetails.sovietProtocolUrl) infoRows.push(new DetailsReactNodeValue('Решение Совета', <ProtocolLink url={examDetails.sovietProtocolUrl} />));
        }

        return infoRows;
    };

    return (
        <Card
          title="Информация об экзамене"
          category="Общая информация об экзамене"
          contentClassName="pt-0"
          withoutPadding={withoutPadding}
          withoutBorder
        >
            <Details infoRows={getInfoRowsFromExamDetails()} withDarkRowLabel />
        </Card>
    );
};

export default ExamInfoTab;

export interface IProps {
    examDetails: IExamDetails;
    appType: AppType;
    withoutPadding?: boolean;
}

interface IPaymentDetails {
    totalAmount: number;
    paid: boolean;
    accountNumber?: string | undefined;
    accountDate?: moment.Moment | undefined;
    aktDocUrl?: string | undefined;
    invoiceForPaymentUrl?: string | undefined;
    sendMarkAsPaid?: () => Promise<void>;
    processingPaid?: boolean;
    amountDescription: string;
}
